import { render, staticRenderFns } from "./IconColors.vue?vue&type=template&id=b82d74e2&"
import script from "./IconColors.vue?vue&type=script&lang=js&"
export * from "./IconColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports